import React, {Component} from "react";
import  {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    Image,
    KeyboardAvoidingView, Alert, Keyboard,
} from "react-native";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
import HMTextView from "../../../customviews/HMTextView";
import {moderateScale} from "../../../tools/Scaling";
import Colors, {colorDark, colorPrimary} from "../../../tools/Colors";
import {typeExport} from "../../../redux/store/type";
import HMActionBar from "../../../customviews/HMActionBar";
import store from "../../../redux/store";
import HMImageView from "../../../customviews/HMImageView";
import i18n from "../../../I18n/i18n";


let container = null;


export default class AboutUsScreen extends Component {


    constructor(props) {
        super(props);

        this.state = {

            modalHeight: 0,
            ddd: [
                "The min size must be a number.",
                "The min size must be less than 4.",
                "The max size must be a number."
            ]

        };

    }

    componentWillReceiveProps(propss) {

    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    componentDidMount() {


    }

    componentWillUnmount() {
        //Tools._RemoveConnectivity()
    }


    render() {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        let DataSplashScreenSaina =checkLogin?(store.getState().reducerSplashGetAllData.resultsShahrdar ? store.getState().reducerSplashGetAllData.resultsShahrdar.result.info : null): (store.getState().reducerSplashGetAllData.resultsSaina ? store.getState().reducerSplashGetAllData.resultsSaina.result.info : null)
        return (
            <View style={{flex: 1}}>
                <HMActionBar back menu props={this.props} statusBarTransparent text={i18n.t('constant.About_software')}
                             headerVisibility
                             more_menu
                             drawer
                             onBackPress={() => this.props.navigation.pop()}/>
                <View style={{position: 'relative', flex: 1}}>


                    <ScrollView>
                        {
                            DataSplashScreenSaina ?
                                <View style={{flex: 1}}>

                                    <View style={{
                                        width: '100%',
                                        height: typeExport._WIDTH /( DataSplashScreenSaina.infimgheight ? DataSplashScreenSaina.infimgheight : 4),
                                        // marginHorizontal: moderateScale(8),
                                        // marginTop: moderateScale(8)
                                    }}>

                                        <HMImageView
                                            resizeMode={"contain"}
                                            _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}

                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                            uriComplete={DataSplashScreenSaina.infimg}
                                            //source_image={item.image}
                                            styleText={{marginTop: moderateScale(10)}} borderRadius={4}/>


                                    </View>
                                    <HMTextView
                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                        text={DataSplashScreenSaina.info}
                                        type={"bold"} style={{
                                        //textAlign: "center",
                                        fontSize: moderateScale(14),
                                        //marginTop:moderateScale(8),
                                        marginHorizontal: moderateScale(8),
                                        marginTop: moderateScale(10),
                                        color: Colors.colorDark,

                                    }}/>
                                </View>
                                :
                                null
                        }
                    </ScrollView>


                </View>
            </View>
        );
    }


}
